import SharedAnnotationsOverlay from './SharedAnnotationsOverlay';

export default SharedAnnotationsOverlay;